import { Button } from './ui/button';
import { isTimeoutError, isOfflineError } from '../utils/requestLifecycle';

/**
 * Calm, recoverable load-error state with Retry — the shared end state for a
 * network-backed screen whose load failed or timed out (never an endless
 * spinner). `onRetry` reruns the CURRENT view/date.
 */
export default function LoadErrorCard({ error, onRetry, title, testId = 'load-error', className = '' }) {
  return (
    <div
      className={'mx-auto max-w-sm rounded-2xl border border-border/40 bg-card p-6 text-center ' + className}
      role="alert"
      data-testid={testId}
    >
      <p className="font-heading font-semibold text-base">{title || "We couldn't load this"}</p>
      <p className="text-sm text-muted-foreground mt-1">
        {isOfflineError(error)
          ? 'No internet connection. Reconnect and try again.'
          : isTimeoutError(error)
            ? 'This is taking longer than usual. Check your connection and try again.'
            : 'Something went wrong. Check your connection and try again.'}
      </p>
      <Button onClick={onRetry} className="mt-4 rounded-full bg-accent text-white hover:bg-accent/90" data-testid={testId + '-retry'}>
        Retry
      </Button>
    </div>
  );
}
